import { COLLECTIONS } from '__constants__'
import { doc, updateDoc } from 'firebase/firestore'

import firestore from 'services/firebase/firestore'

const { USERS } = COLLECTIONS

/**
 * Update the gdpr field of a user document in Firestore.
 * @returns The promise of the update.
 */
const updateGDPRStatus = ({ _id, gdpr, onError }) => {
  return updateDoc(doc(firestore, USERS, _id), { gdpr }).catch((err) => {
    onError && onError(err)
  })
}

export default updateGDPRStatus
